import { initialState } from './state';

const setProp = (state, { prop, value }) => {
  state[prop] = value;
};

const resetState = (state) => {
  Object.assign(state, initialState());
};

export default {
  setProp,
  resetState,
};
